import type { SVGProps } from "react";
export interface AzureAdLogoIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AzureAdLogoIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AzureAdLogoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill="#00BEF2"
        d="M11.912 2q.028.001.074.074c.026.043 2.258 2.72 4.961 5.947 2.703 3.228 4.908 5.884 4.898 5.9-.006.015-2.158 1.78-4.781 3.916a3113 3113 0 0 0-4.956 4.04c-.175.142-.186.148-.25.084-.036-.037-2.273-1.866-4.971-4.065S1.989 13.883 2 13.856c.01-.026 2.226-2.67 4.935-5.883s4.924-5.867 4.934-5.91c.01-.042.027-.063.043-.063"
      />
      <path
        fill="#fff"
        d="M11.546 18.818c-.307-.111-.678-.43-.832-.726-.19-.366-.175-.938.037-1.394.165-.34.165-.35.059-.43a49 49 0 0 0-1.559-.863l-1.537-.833c-.063-.037-.17 0-.36.122-.62.393-1.267.35-1.776-.122-.366-.339-.472-.577-.472-1.065 0-.472.096-.716.398-1.018.408-.408.954-.546 1.479-.37.286.095.291.095.472-.043.212-.16 1.913-1.712 2.735-2.491l.567-.54-.17-.356c-.344-.716-.17-1.51.435-1.988.328-.26.572-.339 1.044-.339 1.102 0 1.87 1.156 1.457 2.19-.11.285-.11.29-.005.466.09.153 1.622 2.003 2.433 2.947.143.164.302.297.355.297s.233-.053.403-.117a1.48 1.48 0 0 1 1.95.821c.212.504.027 1.182-.424 1.59-.318.287-.55.377-.975.377-.297 0-.408-.032-.72-.202-.234-.127-.414-.19-.488-.17-.127.033-2.083 1.374-2.518 1.723-.265.218-.286.297-.148.62.132.319.116.817-.032 1.13-.164.344-.573.689-.928.795-.36.1-.578.1-.88-.011m.09-5.841V9.956l-.17-.233c-.095-.128-.185-.234-.2-.234-.07 0-3.493 3.112-3.493 3.175 0 .016.053.175.116.345.064.175.111.424.106.567s-.005.302-.005.355c.005.122 1.15.853 2.867 1.845.472.275.636.344.695.296.069-.058.085-.646.085-3.095m1.453 2.671c2.268-1.425 2.692-1.712 2.719-1.818a4 4 0 0 0 .042-.562l.016-.445-1.155-1.373c-1.24-1.468-1.696-1.966-1.802-1.966-.038 0-.223.106-.414.233l-.35.234.016 3.015c.016 2.704.037 3.16.138 3.16.01.005.371-.213.79-.478"
      />
    </svg>
  );
}
